import axios from "axios";

import { IStarFuneral } from "./mourning-card/interfaces";


type Attendee = {
  firstName: string;
  lastName: string;
  email: string;
  wheelchair?: boolean;
  ageIssues?: boolean;
  impairments?: boolean;
  isExpanded?: boolean;
};

export const starApi = {
  async getStar(starUuid: string): Promise<IStarFuneral> {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_API_URL}public/star/${starUuid}/`,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    const data = response.data;

    return {
      star: {
        uuid: data.uuid,
        firstName: data.first_name,
        dateOfBirth: new Date(data.date_of_birth),
        dateOfDeath: new Date(data.date_of_death),
        lastName: data.last_name,
        photo: data.photo,
        background: data.background,
      },
      funeral: {
        isPublic: data.funeral.is_public,
        type: data.funeral.type,
        uuid: data.funeral.uuid,
        date: new Date(data.funeral.date),
        time: data.funeral.time,
        liveStream: null,
        document: data.funeral.document,
      }
    }
  },
  async confirmPresence(funenralUuid: string, attendess: Attendee[]): Promise<void> {
    const payload = attendess.map((attendee) => ({
      name: `${attendee.firstName} ${attendee.lastName}`,
      email: attendee.email,
      physical_limitation_assistance: attendee.wheelchair,
      age_issues_assistance: attendee.ageIssues,
      impairments_assistance: attendee.impairments,
    }))

    await axios.post(
      `${process.env.REACT_APP_BASE_API_URL}funeral/${funenralUuid}/attendee/`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }
};
